import { StyleProp, StyleSheet } from 'react-native';
import { TextStyle } from '@expo/html-elements/build/primitives/Text';
import { useMemo } from 'react';
import { isSafariOnDesktop } from 'src/_shared/utils/is-safari-on-desktop/isSafariOnDesktop';
import { FontStyle } from 'src/constants/font.constants';
import { getLatoFontFamily } from 'src/helpers/font.helper';

export function useLatoFont(style: StyleProp<TextStyle> | undefined) {
  const latoFontStyle = useMemo(() => {
    if (style) {
      return {
        fontFamily: getLatoFontFamilyByStyle(style),
      };
    } else {
      return undefined;
    }
  }, [style]);

  return latoFontStyle;
}

export const getLatoFontFamilyByStyle = (style: StyleProp<TextStyle>) => {
  const safariOnDesktop = isSafariOnDesktop();
  const flattenStyle = StyleSheet.flatten(style);
  const fontWeight = flattenStyle.fontWeight;
  const fontStyle = flattenStyle.fontStyle;

  if (fontWeight === 100 && fontStyle === 'italic') {
    return getLatoFontFamily(FontStyle.ThinItalic);
  }

  if (fontWeight === 100) {
    return getLatoFontFamily(FontStyle.Thin);
  }

  if (fontWeight === 300 && fontStyle === 'italic') {
    return getLatoFontFamily(FontStyle.LightItalic);
  }

  if (fontWeight === 300) {
    return getLatoFontFamily(FontStyle.Light);
  }

  if (fontWeight === 400 && fontStyle === 'italic') {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.Italic);
  }

  if (fontWeight === 400) {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Regular);
  }

  if (fontWeight === 500 && fontStyle === 'italic') {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.Italic);
  }

  if (fontWeight === 500) {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Regular);
  }

  if (fontWeight === 700 && fontStyle === 'italic') {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.BoldItalic);
  }

  if (fontWeight == 700) {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Bold);
  }

  if (fontWeight == 900 && fontStyle === 'italic') {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.BlackItalic);
  }

  if (fontWeight == 900) {
    return getLatoFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Black);
  }

  return getLatoFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Regular);
};
